import { AVATAR_MAX_FILE_SIZE_MB } from "@circle-react-shared/AiConversation/composer/Attachments/constants";
import { ComposerArea } from "@circle-react-shared/AiConversation/composer/ComposerArea";
import { ComposerErrorToast } from "@circle-react-shared/AiConversation/composer/ComposerError/ComposerErrorToast";
import { truncate } from "lodash";
import type { ReactNode } from "react";

import { t } from "@/i18n-js/instance";
import { useUploadAttachments } from "@/react/components/CircleAi/Home/Attachments/useUploadAttachments";
import type { TiptapContent } from "@/react/components/SettingsApp/CommunityInbox/BotChatRoom/MessageBox";

interface AvatarComposerProps {
  agentName: string;
  isAttachmentsEnabled?: boolean;
  isProcessing?: boolean;
  isUnavailable?: boolean;
  onSubmit: (content: TiptapContent) => void;
  statusSlot?: ReactNode;
}

export const AvatarComposer = ({
  agentName,
  isAttachmentsEnabled = false,
  isProcessing = false,
  isUnavailable = false,
  onSubmit,
  statusSlot,
}: AvatarComposerProps) => {
  const {
    attachments,
    isUploading,
    signedIds,
    addFiles,
    removeAttachment,
    clearAttachments,
  } = useUploadAttachments({ maxFileSizeMb: AVATAR_MAX_FILE_SIZE_MB });

  return (
    <ComposerArea
      testId="avatar-composer"
      statusSlot={
        <>
          <ComposerErrorToast />
          {statusSlot}
        </>
      }
      isRunning={false}
      disabled={isProcessing}
      isUnavailable={isUnavailable}
      attachments={attachments}
      isUploading={isUploading}
      onAddFiles={isAttachmentsEnabled ? addFiles : undefined}
      onRemoveAttachment={removeAttachment}
      placeholder={t("community_inbox.message_bot", {
        agent_name: truncate(agentName, { length: 40 }),
      })}
      onSend={(_annotatedText, { sgids_to_object_map, ...doc }) => {
        onSubmit({
          body: {
            body: doc,
            attachments: signedIds,
            localAttachments: [],
            localSgidToObjectMap: sgids_to_object_map ?? {},
          },
        });
        clearAttachments();
      }}
    />
  );
};
